import myzod, { Infer } from 'myzod'
import { sessionSchema } from '../../entities/app/context/session'

export enum JobEventType {
  CREATED = 'CreatedJob',
  CANCEL = 'CancelJob',
}

export enum JobInitiationRoute {
  API = 'api',
  SMS = 'sms',
}

export const jobEventSchema = myzod.object({
  jobId: myzod.string(),
  initiatedBy: sessionSchema,
  initiatedVia: myzod.enum(JobInitiationRoute),
})

export type JobEvent = Infer<typeof jobEventSchema>

export const jobAwardedEventSchema = myzod.object({
  pk: myzod.string().pattern(/^User#/),
  sk: myzod.string().pattern(/^Job#/),
  id: myzod.string().pattern(/^Job#/),
  awardedToId: myzod
    .string()
    .pattern(/^User#/)
    .optional(),
})
export type JobAwardedEvent = Infer<typeof jobAwardedEventSchema>
